// extracted by mini-css-extract-plugin
export default {"signerWrapper":"UjFqCpJyGdjhq7Hn_sCZ","heading":"jk1tP1CFk_YbQghTqM4x","headingTitle":"jC9I2_8HkvkOmTKxFCDQ"};